import {noView} from 'aurelia-framework';
import { pluralFormatter } from './index.js';

@noView
export class GroupsCounterValueConverter {
	toView(value, groupType = 'Group') {
		return pluralFormatter(value, groupType);
	}
}
